// removed by extract-text-webpack-plugin
module.exports = {"LargeSearchBox":"_1FRr2gP15ZDoHRsCDHrwiP","LargeSearchBox__tags":"_32gOjF5Zp0CVkij6WaAg8R","LargeSearchBox__field":"_3_og_N_CZ2If7JSTJ0xT_4","LargeSearchBox__suggestedTags":"_1JKYjPfVmYYPNcNbf_4W7Z","LargeSearchBox__suggestedTags--loading":"_1i6Bbr9oO4kSN6LJ4H16MY","Tag":"_10ELE3MV4qYgmmXLZWN47S","Tag--applied":"opNVNTgmX8JctD_Lu2Gsf","Tag--suggested":"_3PqA0ENIB-wUNpqnAYkf44","TagSeparator":"_2goMpRLPnIGDJtsEhhu8l3"};


//////////////////
// WEBPACK FOOTER
// ./src/components/LargeSearchBox/LargeSearchBox.scss
// module id = 1065
// module chunks = 0